

export default {
    getFilteredSubKategori : (state) => (id) => state.subKategoriSOSList.filter(v => v.kategori.id === id),
    getFilteredSyarat: state => id => state.syaratList.filter(v => v.kategori !== null).filter(v => v.kategori.id == id),
    getFilteredSyaratKumpul: state => id => state.syaratKumpuls.filter(v => v.sos !== undefined).filter(v => v.sos !== null).filter(v => v.sos.id == id)
}
